import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './styles.scss';

/**
 * A tooltip component that renders via React Portal to escape ag-grid overflow clipping.
 * Positions itself above the referenced input element using fixed positioning.
 * 
 * @param {Object} props
 * @param {React.RefObject} props.inputRef - Ref to the input element to position above
 * @param {string} props.message - The error message to display
 */
const ErrorTooltipPortal = ({ inputRef, message }) => {
    const [position, setPosition] = useState(null);

    useEffect(() => {
        if (inputRef.current) {
            const rect = inputRef.current.getBoundingClientRect();
            setPosition({
                top: rect.top - 40,
                left: rect.left,
            });
        }
    }, [message]);

    if (!position) return null;

    return ReactDOM.createPortal(
        <div className="inline-edit-error-tooltip" style={{
            position: 'fixed',
            top: position.top,
            left: position.left,
        }}>
            {message}
        </div>,
        document.body
    );
};

export default ErrorTooltipPortal;
